export const TravelIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7590_57030"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7590_57030)">
        <path
          d="M9.47438 8.72125L4.36854 6.54646C4.08868 6.42576 3.92341 6.21854 3.87271 5.92479C3.82188 5.6309 3.90438 5.37604 4.12021 5.16021L4.34771 4.90396C4.45674 4.79493 4.57639 4.72625 4.70667 4.69792C4.83709 4.66958 4.97229 4.66667 5.11229 4.68917L12.2285 5.9825L14.7371 3.47437C14.9819 3.22549 15.2803 3.10104 15.6323 3.10104C15.9842 3.10104 16.2847 3.22382 16.5335 3.46937C16.7826 3.71507 16.9071 4.01451 16.9071 4.36771C16.9071 4.7209 16.7826 5.02194 16.5335 5.27083L14.0175 7.77875L15.3183 14.8837C15.3411 15.0179 15.337 15.1488 15.306 15.2765C15.2751 15.4041 15.2051 15.5224 15.096 15.6315L14.8398 15.8877C14.6206 16.1035 14.3633 16.1848 14.0679 16.1315C13.7724 16.078 13.5633 15.9113 13.4406 15.6315L11.2788 10.5175L9.04167 12.7627L9.49188 15.3542C9.51438 15.4664 9.51014 15.5681 9.47917 15.6594C9.4482 15.7508 9.39396 15.8356 9.31646 15.9137L9.03979 16.1846C8.88479 16.3436 8.69973 16.4049 8.48459 16.3685C8.26945 16.3323 8.11271 16.2201 8.01438 16.0321L6.59292 13.3998L3.94709 11.9856C3.75903 11.8873 3.64688 11.7306 3.61063 11.5154C3.57424 11.3003 3.63556 11.1152 3.79459 10.9602L4.06542 10.6835C4.14361 10.606 4.23306 10.5505 4.33375 10.5169C4.43445 10.4833 4.53848 10.4776 4.64584 10.5L7.24521 10.9665L9.47438 8.72125Z"
          fill="#2E2E2E"
        />
      </g>
    </svg>
  );
};
